import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { fetchCmsMetaData } from "../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";
import {
  ImageSkeleton,
  LineSkeleton,
} from "../../../Components/Utility/Skeletons";
import OtherInfo from "../../Users/OtherInfo";

function HostExperience() {
  const token = localStorage.getItem("authToken");
  const [listings, setListings] = useState([]);
  const [baseUrl, setBaseUrl] = useState(""); // store base_url
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showOtherInfoModal, setShowOtherInfoModal] = useState(false);
  const closeOtherInfo = () => setShowOtherInfoModal(false);
const [meta,setMeta] = useState();
  const host = JSON.parse(localStorage.getItem("user"));
  const hostId = host?.id;


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    const fetchListings = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/experience-list`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (res.data?.data) {
          setListings(res.data.data);
          if (res.data.base_url) setBaseUrl(res.data.base_url);
        }
      } catch (err) {
        console.error("Failed to fetch listings", err);
      } finally {
        setLoading(false);
      }
    };

    fetchListings();
  }, [token]);

  const handleDelete = async (experienceId) => {
    if (!window.confirm("Are you sure you want to delete this experience?"))
      return;

    // show a loading toast
    const loadingToast = toast.loading("Deleting experience...");

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE}/host/delete-experience/${experienceId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Remove from UI instantly
      setListings((prev) =>
        prev.filter((item) => item.experience_id !== experienceId)
      );

      toast.success("Experience deleted successfully!", { id: loadingToast });
    } catch (err) {
      console.error("Failed to delete experience", err);
      toast.error("Failed to delete experience!", { id: loadingToast });
    }
  };

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("listing");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <section className="ser_v_araeea allpages dashboardpgs listings al_bootm_spance">
       <SetMetaTags
        title= {meta?.meta_title || "Listing | Weyfarin"}
        description={meta?.meta_description || "Listing | Weyfarin"}
      
      />

      <div className="container">
        {/* <div className="bedcramss">Dashboard &gt; Your listings</div> */}
        <div className="ds_listsng">
          <h3 className="mb-4">
            Your Listings{" "}
            <span className="ads_btnssrts">
              <button
                className="btn btn-primary"
                // onClick={() =>
                //   navigate("/reservation", {
                //     state: { isOtherExperience: true },
                //   })
                // }
                onClick={() => {
                  if (host?.signup_complete_status === "0") {
                    setShowOtherInfoModal(true);
                  } else if (host?.host_profile === 0) {
                    navigate("/host-category");
                  } else {
                    navigate("/reservation", {
                      state: { isOtherExperience: true },
                    });
                  }
                }}
              >
                Add Listing
              </button>
            </span>
          </h3>

          <div className="row">
            {loading ? (
              // Show 4 skeleton cards while loading
              Array.from({ length: 4 }).map((_, idx) => (
                <div key={idx} className="col-lg-3 col-sm-6">
                  <div className="bike_ara_all">
                    <div className="bike_mg_ar">
                      <ImageSkeleton height="180px" />
                    </div>
                    <div className="tx_box">
                      <LineSkeleton width="80%" />
                      <LineSkeleton width="60%" />
                    </div>
                  </div>
                </div>
              ))
            ) : listings.length > 0 ? (
              listings.map((item) => {
                // {listings.length > 0 ? (
                //   listings.map((item) => {
                const imageUrl = item.experience_image
                  ? `${baseUrl}${item.experience_image}`
                  : "images/choose_experiences_sm1.jpg";
                return (
                  <div key={item.experience_id} className="col-lg-3 col-sm-6">
                    <div className="bike_ara_all">
                      <div className="bike_mg_ar">
                        <span className="reatingsg_txt">
                          {item.status === 0 ? (
                            <span className="inpross"></span>
                          ) : (
                            <span className="inpross_green"></span>
                          )}

                          {/* <span className="inpross"></span>{" "} */}
                          <span
                            style={{
                              color: item.status === 1 ? "green" : "orange",
                            }}
                          >
                            {item.status === 1 ? "Published" : "In Progress"}
                          </span>
                        </span>
                        <span className="reatingsg ones">
                          <i
                            className="fa fa-pencil"
                            onClick={() =>
                              navigate("/reservation", {
                                state: {
                                  isOtherExperience: true,
                                  experienceId: item.experience_id, // pass id here
                                  isEdit: true,
                                },
                              })
                            }
                          ></i>
                        </span>
                        <span
                          className="reatingsg two"
                          onClick={() => handleDelete(item.experience_id)}
                        >
                          <i className="fa fa-trash"></i>
                        </span>
                        <div className="mdll">
                          <img
                            onClick={() => {
                              if (item.status === 1) {
                                const expSlug = `/experience/${item.url_slug}`;
                                navigate(expSlug);
                              }
                            }}
                            style={{
                              cursor: item.status === 1 ? "pointer" : "default",
                            }}
                            src={imageUrl}
                            className="mg_sm_araea"
                            alt={item.title}
                          />
                        </div>
                      </div>
                      <div className="tx_box">
                        <h4>{item.title}</h4>
                        <p>
                          Experience in {item.country_name}, {item.city_name}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="nodata">
                <p>No listings found.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showOtherInfoModal && (
        <OtherInfo
          isOpen={showOtherInfoModal}
          onClose={closeOtherInfo}
          user={host} // or userDetails if you have
          userType={host?.user_type}
        />
      )}
    </section>
  );
}

export default HostExperience;
